import Button from "components/ui/Button";
import "./UserDetailsNotAllowed.css";

const ADMINS_EMAIL = "scheduling@talaera.com";

export default function UserDetailsNotAllowed() {
  return (
    <div className="user-details-not-allowed">
      <p>Sorry, you’re not allowed to see this page.</p>
      <p>
        If you believe this is incorrect, please contact&nbsp;
        <Button as="a" variant="plain" href={"mailto:" + ADMINS_EMAIL}>
          {ADMINS_EMAIL}
        </Button>
      </p>
    </div>
  );
}
